import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import { ref, computed, watch, onMounted } from 'vue'
import { useVModel } from '@vueuse/core'
import dayjs from 'dayjs'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { toBeijingTime } from '@/utils/timeFormat'
import type { Dayjs } from 'dayjs'


const __default__ = { name: 'CosSingleDateTimePicker' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  startTime: String,
  endTime: String,
  view: Boolean,
  // 是否时间范围
  isRange: {
    type: Boolean,
    required: true
  },
  placeholder: {
    type: String
  },
  valueFormat: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  format: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  defaultValue: {
    type: String // 设置【now】 默认当前时间
  },
  // 输出北京时间
  isOutputBeijingTime: {
    type: Boolean
  }
},
  emits: ['update:startTime', 'update:endTime', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const startTimeValue = useVModel(props, 'startTime', emit)
const endTimeValue = useVModel(props, 'endTime', emit)
const defaultStartTime = '09:00:00'
const defaultEndTime = '18:00:00'
let startTimePage: string | undefined = ''
let endTimePage: string | undefined = ''

const inputValue = computed(() => {
  if (!props.view) return undefined
  try {
    if (props.isRange) {
      if (startTimeValue.value && endTimeValue.value) {
        const date = startTimeValue.value.split(' ')[0]
        const start = startTimeValue.value.split(' ')[1]
        const end = endTimeValue.value.split(' ')[1]
        return `${date} ${start}-${end}`
      } else {
        return undefined
      }
    } else {
      return startTimeValue.value || endTimeValue.value
    }
  } catch (error) {
    console.error(error)
    return undefined
  }
})

onMounted(() => {
  if (props.defaultValue === 'now') {
    const now = dayjs()
    startTimeValue.value = now.format(`${props.valueFormat} HH:mm:ss`)
  }
})

const onChange = (value: string | Dayjs, dateString: string) => {
  // 区分单个时间和时间范围，单个时间只有开始时间（时分秒）
  if (props.isRange) {
    startTimePage = value ? `${value} ${defaultStartTime}` : undefined
    endTimePage = value ? `${value} ${defaultEndTime}` : undefined
  } else {
    startTimePage = value ? `${value} ${defaultStartTime}` : undefined
    endTimePage = value ? `${value} ${defaultStartTime}` : undefined
  }
  // 默认为电脑本地时间，如果需要转换为北京时间，需要传入isOutputBeijingTime
  startTimePage =
    startTimePage && props.isOutputBeijingTime
      ? toBeijingTime(startTimePage, `${props.valueFormat} HH:mm:ss`)
      : startTimePage
  endTimePage =
    endTimePage && props.isOutputBeijingTime ? toBeijingTime(endTimePage, `${props.valueFormat} HH:mm:ss`) : endTimePage
  startTimeValue.value = startTimePage
  endTimeValue.value = endTimePage
  emit('change', value, dateString)
}

const dateValue = ref<string | Dayjs>()
watch(
  () => [props.startTime, props.endTime],
  (val) => {
    setTimeout(() => {
      const [startTime, endTime] = val
      if (startTime === startTimePage && endTime === endTimePage) return
      if (props.isRange) {
        dateValue.value = startTime && endTime ? dayjs(startTime).format(props.valueFormat) : undefined
      } else {
        dateValue.value = startTime || endTime
      }
    }, 0)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({ key: 0 }, _ctx.$attrs, { value: inputValue.value }), null, 16, ["value"]))
    : (_openBlock(), _createBlock(_component_a_date_picker, _mergeProps({ key: 1 }, _ctx.$attrs, {
        value: dateValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
        format: props.format,
        valueFormat: __props.valueFormat,
        placeholder: __props.placeholder || _ctx.$t('common.pleaseSelect'),
        style: {"width":"100%"},
        onChange: onChange
      }), null, 16, ["value", "format", "valueFormat", "placeholder"]))
}
}

})